import { useState } from "react";
import { collect, useProps } from "react-recollect";
import Loading from "components/Loading";
import { API_URL, certPOST } from "lib/API";
import FullsizeMessage from "components/FullsizeMessage";
import Page from "components/Page";
import OrderLine from "components/OrderLine";
import useLoad from "lib/useLoad";
import { ButtonPrimary } from "components/Buttons";
import LoadShopifyOrders, {
  needToLoadShopifyOrders,
} from "components/loaders/LoadShopifyOrders";
import { ChevronDoubleRightIcon } from "@heroicons/react/outline";
import { LoadingButtonPrimary } from "components/LoadingButtons";
import { format } from "date-fns";

function CertificatesNew({ store }) {
  useProps([store.shopifyOrders]); // for some reason recollect doesn't detect us reading this
  const [showingSettingMessage, setShowingSettingMessage] = useState(false);
  const { data: researches, reload } = useLoad("certificateResearch", {
    status: "new",
  });

  const shopifyOrderIds = researches?.map((r) => r.shopifyOrdersId);

  function setOrdersAsBeingResearched(id = null) {
    setShowingSettingMessage(true);
    const ids = id ? [id] : researches.map((r) => r._id);
    certPOST("setStatus", { status: "typing", ids }).then((r) => {
      setShowingSettingMessage(false);
      reload();
    });
  }

  const downloadFilename = `${API_URL}pdfNewOrders/orders_${format(new Date(), "yyyy-MM-dd")}.pdf?token=${store.token}`;

  return researches === undefined ? (
    <Loading text="Loading New orders" />
  ) : researches.length === 0 ? (
    <FullsizeMessage>No new orders!</FullsizeMessage>
  ) : showingSettingMessage ? (
    <Loading text="Setting order statuses to 'typing'..." />
  ) : needToLoadShopifyOrders(shopifyOrderIds, store) ? (
    <LoadShopifyOrders ids={shopifyOrderIds} />
  ) : (
    <Page title="New" heading="New orders from Shopify">
      <iframe
        src={downloadFilename}
        width="100%"
        height="600px"
        style={{ minHeight: "70vh" }}
        title="New research slips"
      ></iframe>
      <div className="p-4 bg-slate-200 shadow-lg mb-2 flex items-center">
        <a href={downloadFilename} target="_blank" rel="noopener noreferrer">
          <button
            className="w-52 btn bg-gradient-to-br from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 text-white inline-flex items-center transition duration-150 ease-in-out cursor-pointer"
            type="button"
          >
            Download PDF of new orders
          </button>
        </a>
        <LoadingButtonPrimary onClick={() => setOrdersAsBeingResearched()}>
          Set all to "Typing up"
        </LoadingButtonPrimary>
      </div>
      {researches.map((r) => (
        <OrderLine key={r._id} r={r}>
          <div className="btn-group">
            <ButtonPrimary onClick={() => setOrdersAsBeingResearched(r._id)}>
              <ChevronDoubleRightIcon className="size-6" />
              &nbsp;Set to "typing up"
            </ButtonPrimary>
          </div>
        </OrderLine>
      ))}
    </Page>
  );
}

export default collect(CertificatesNew);
